let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bpNdl")).then(() => parcelRequire('5h9Nf'));